import { render, staticRenderFns } from "./DialogConfirmation.vue?vue&type=template&id=6053227b&scoped=true&"
import script from "./DialogConfirmation.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmation.vue?vue&type=style&index=0&id=6053227b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053227b",
  null
  
)

export default component.exports